import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitPwaActionPayload, IPwaInstallPromptEvent } from "./pwa.t";

export interface IPwaState {
    isInited: boolean,
    isPwaAllowed: boolean,
    isPwaMode: boolean,
    installPromptEvent: null | IPwaInstallPromptEvent,
}

const initialState: IPwaState = {
    isInited: false,
    isPwaAllowed: false,
    isPwaMode: false,
    installPromptEvent: null,
}

export const pwaSlice = createSlice({
    name: 'pwa',
    initialState,
    reducers: {
        initPwaAction(state, action: PayloadAction<IInitPwaActionPayload>) {
            state.isPwaMode = action.payload.isPwaMode;
            state.isInited = true;
        },
        initPwaWebPushNotificationsAction(state, action: PayloadAction) {},
        setInstallPromptEventAction(state, action: PayloadAction<IPwaInstallPromptEvent>) {
            state.installPromptEvent = action.payload;
        },
        setIsPwaAllowedAction(state, action: PayloadAction<boolean>) {
            state.isPwaAllowed = action.payload;
        },
        openPwaInstallPromptAction(state, action: PayloadAction) {}
    }
});

export default pwaSlice.reducer;
